import { storeMailOps } from '@/api/store/mail';
import { watchMailMessage } from '@/api/store/mail/message';
import { inWindow } from '@/config';
export const storeOps = {
    mail: Object.assign({}, storeMailOps),
};
export function storeOpRegister(type, ops) {
    if (inWindow()) {
        if (!storeOps[type]) {
            console.error('Not Implement Store in API');
        }
        Object.assign(storeOps[type], ops);
        console.log('Store Register success', type, storeOps);
    }
}
export function startWatchMailMessage() {
    if (inWindow()) {
        const messageWatchers = [watchMailMessage];
        messageWatchers.forEach(watcher => watcher());
    }
}
